<span class="input-group">
  <input data-cy="inputProfileQuickSearch" type="text" class="form-control" (keyup.enter)="enterPressed.emit(Keyword)"
    [(ngModel)]="Keyword" />
  <span class="input-group-btn">
    <button pButton type="button" class="btn btn-default" (click)="reset()"
      [icon]="isSearching ? 'pi pi-spin pi-spinner' : 'pi pi-times-circle'">
    </button>
  </span>
</span>